import useLaunchRealTimeActivity from './useLaunchRealTimeActivity.hook';
import { StyledLaunchRealTimeActivity } from './LaunchRealTimeActivity.styled';
import ActionsFooter from '@/shared/StepActionsFooter/StepActionsFooter';
import AvaialbleLiveTasks from './AvaialbleLiveTasks/AvaialbleLiveTasks';
import TaskStudentsEditor from '@/shared/TaskStudentsEditor/TaskStudentsEditor';
import { Alert, Select, Space, Spin, Switch } from 'antd';
import RealTimeActivityConf from './RealTimeActivityConf/RealTimeActivityConf';
import LiveTag from '@/shared/LiveTag/LiveTag';

export default function LaunchRealTimeActivity({
  onActionCancelled,
  task,
  clazz,
  activityId,
}) {
  const { state, actions } = useLaunchRealTimeActivity({
    task,
    clazz,
    activityId,
  });

  return state.runningRealTimeActivity && !state.processing ? (
    <StyledLaunchRealTimeActivity
      title={
        <div className="title-with-icon">
          <div className="title">
            <LiveTag /> task already in progress
          </div>
        </div>
      }
      onClose={onActionCancelled}
      footer={
        <ActionsFooter
          finish={<span>End task and launch a new one</span>}
          finishAction={actions.endActivity}
          cancel={<span>Resume task</span>}
          cancelAction={actions.resumeActivity}
          processing={state.ending}
        />
      }
    >
      <p>
        There's a live task already in progress in your account. Please, end it
        or resume it before you run a new one
      </p>
      <ul>
        <li>{state.runningRealTimeActivity?.activity?.name}</li>
      </ul>
      <Alert
        type="warning"
        message="You can only run one live task at a time"
      />
    </StyledLaunchRealTimeActivity>
  ) : (
    <StyledLaunchRealTimeActivity
      className={(task || activityId) && !state.changeStudents ? '' : 'large'}
      title={
        <div className="title-with-icon">
          <div className="title">
            {task ? 'Resume' : 'Start'} <LiveTag /> task
          </div>
        </div>
      }
      onClose={onActionCancelled}
      footer={
        <>
          {state.selectedClass && !state.selectedClass?.internalUse ? (
            <Space className="mb pointer">
              <Switch
                checked={state.changeStudents}
                onChange={actions.setChangeStudents}
              />
              <span
                onClick={() => actions.setChangeStudents(!state.changeStudents)}
              >
                Assign it only to the students I choose
              </span>
            </Space>
          ) : null}
          <ActionsFooter
            cancel="Cancel"
            cancelAction={onActionCancelled}
            finish={task ? 'Resume' : 'Start'}
            disabled={
              (!state.selectedActivity && !task) || !state.selectedClass
            }
            finishAction={actions.launch}
            processing={state.processing}
          />
        </>
      }
    >
      <div className="columns">
        {task || activityId ? null : (
          <div className="tasks">
            <AvaialbleLiveTasks
              selectedActivity={state.selectedActivity}
              setSelectedActivity={actions.setSelectedActivity}
            />
          </div>
        )}
        {state.changeStudents && (
          <div className="students">
            <TaskStudentsEditor
              taskId={task?.id}
              classId={state.selectedClass.id}
              selectedStudents={state.selectedStudents}
              setSelectedStudents={actions.setSelectedStudents}
            />
          </div>
        )}
        <div className="info">
          <ol>
            <li>Share your screen and audio with your students</li>
            <li>Tell your students to go to Rockalingua website</li>
            <li>They will see the LIVE task to click on</li>
            <li>We will track their progress just like any other task</li>
          </ol>

          {state.isTeacherPro && !clazz ? (
            <div className="mb">
              <p>Select a class to play with:</p>
              <Select
                placeholder="Select a class"
                className="w-100"
                value={state.selectedClass?.id}
                options={state.classes.map((clazz) => ({
                  value: clazz.id,
                  label: clazz.name,
                }))}
                onChange={(classId) => {
                  const clazz = state.classes.find(
                    (clazz) => clazz.id === classId
                  );
                  actions.setSelectedClass(clazz);
                }}
                loading={state.loading}
              />
            </div>
          ) : null}

          {state.loading ? (
            <div className="loading">
              <Spin spinning />
            </div>
          ) : null}

          {task ? null : (
            <RealTimeActivityConf
              data={state.selectedActivity?.data}
              setConf={actions.setConf}
            />
          )}
        </div>
      </div>
    </StyledLaunchRealTimeActivity>
  );
}
